import Body from 'commons/card/Body';
import React from 'react';

export default function LoadingCardBody() {
  return (
    <Body>
      <div className="k-loading-mask">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
      </div>
    </Body>
  );
}
